var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeritageExplorerAttract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1791,
    height: 2149,
    viewBox: "0 0 1791 2149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1210.22 605.121H2418.91H2418.61C2418.61 271.137 2148.1 0.625 1814.42 0.625C1480.73 0.625 1210.22 271.439 1210.22 605.121ZM1210.22 605.121C1210.22 271.439 939.408 0.625 605.726 0.625C271.742 0.625 1.23009 271.439 1.23009 605.121C1.23009 938.803 272.044 1209.62 605.726 1209.62C939.408 1209.62 1210.22 938.803 1210.22 605.121ZM1209.92 1814.11C1209.92 2147.8 939.105 2418.61 605.424 2418.61C272.044 2418.61 1.23009 2147.8 1.23009 1814.11H1209.92ZM1209.92 1814.11C1209.92 2147.8 1480.73 2418.61 1814.42 2418.61C2148.1 2418.61 2418.91 2147.8 2418.91 1814.11C2418.91 1480.43 2148.1 1209.62 1814.42 1209.62C1480.43 1209.62 1209.92 1480.43 1209.92 1814.11ZM2418.91 1209.62C2418.91 875.935 2148.1 605.121 1814.72 605.121C1481.34 605.121 1210.52 875.935 1210.52 1209.62H1814.72H2419.21H2418.91ZM605.121 1814.11C938.803 1814.11 1209.31 1543.3 1209.31 1209.92H605.121H0.625C0.625 1543.6 271.137 1814.11 604.819 1814.11H605.121Z",
    stroke: "#CAFBF9",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeritageExplorerAttract);
export default __webpack_public_path__ + "static/media/heritage-explorer-attract.7ace00b7409d4d690c0c0025a2691c32.svg";
export { ForwardRef as ReactComponent };